import * as CoreFns from '../../utilities/CoreFns';
import * as StandardFns from '../../utilities/StandardFns';
import * as ResponsiveFns from '../../utilities/ResponsiveFns';
import * as SearchForAnEntityWithPath from '../../utilities/SearchForAnEntityWithPath';

export function consolidateAPathForm(oPath, goToAKeyPath, currentList, actionCases){
    var errorMsg = '';
    var relevantSpace =  CoreFns.goDownPath(currentList, oPath, 0);

    function pieceTogetherTree(keyPath, thisPathDown, mapsAndFiltersAbove){

      var node = CoreFns.goDownPath(relevantSpace, keyPath, 0);


      var xS = node.x;
      if (xS.length === 0){
        errorMsg = 'Missing Node';
        goToAKeyPath(keyPath, thisPathDown);
        return;
      }
      var firstNode = xS[0];
      var v = [];
      var ft = firstNode.t;

      function getP(nos){
        var ppp = firstNode.p;
        var v1 = [];
        for (var i2 = 0; i2 < ppp.length; i2++){
          var aP = ppp[i2];
          if (aP.t === 'l'){
            var aNodeKey2 = xS[nos + 1];
            nos ++;
            var pp = pieceTogetherTree(['y', aNodeKey2.v], thisPathDown.concat([{k:aNodeKey2.v, i:nos, up:1, isRequired:1}]), mapsAndFiltersAbove);
            if (!pp){
              return;
            }
            if (aP.y){
              pp.y = aP.y;
            }
            v1.push(pp);
          }else if (aP.t === 'oP'){
            v1.push({t:'oP',n:aP.n});
          }
        }
        return v1;        
      }

      if (ft === 'f' ){
        for (var i = 1; i < xS.length; i++){
          var aNodeKey = xS[i];
          var up = 1;
          if (firstNode.v === 60){
            up = 0;
          }
          var isRequired = 1;
          var relevantFn = StandardFns.functionalPieces[firstNode.v];
          var min = relevantFn.min;
          if (xS.length - 1 <= min){
            isRequired = 0;
          }

          var toConcat = [];
          if (firstNode.v === 58 || firstNode.v === 59 || firstNode.v === 24){
            if (i === 2){
              toConcat = [firstNode];
            }
          }else if (firstNode.v === 71){
            if (i === 3){
              toConcat = [firstNode];
            }
          }

          var p = pieceTogetherTree(['y', aNodeKey.v], thisPathDown.concat([{k:aNodeKey.v, i, up, isRequired}]), mapsAndFiltersAbove.concat(toConcat));
          if (errorMsg){
            return;
          }
          if (!p){
            return;
          }
          if (firstNode.v === 61){
            p.ti = aNodeKey.ti;
          }
          v.push(p);
        }
        var basic = {t:ft,i:firstNode.v, v};
        if (firstNode.v === 58 || firstNode.v === 59 || firstNode.v === 71 || firstNode.v === 24){
          basic.m0 = firstNode.m0
          if (firstNode.v === 71 || firstNode.v === 24){
            basic.m1 = firstNode.m1;
          }
        }
        
        return basic;
      }else if (ft === 'eS' || ft === 'eV'){

        var nos1;
        if (ft === 'eS'){
          var thisAbi = ResponsiveFns.getToRelevantAbi(firstNode, currentList); 
          nos1 = thisAbi.inputs.length ;
        }
        for (var i5 = 1; i5 < xS.length; i5++){
          if (i5 < nos1 + 1 || i5 === xS.length - 1){
            var aNodeKey1 = xS[i5];
            var p5 = pieceTogetherTree(['y', aNodeKey1.v], thisPathDown.concat([{k:aNodeKey1.v, i:i5, up:1, isRequired:1}]), mapsAndFiltersAbove);
            if (errorMsg){
              return;
            }
            if (!p5){
              return;
            }
            v.push(p5);            
          }
        }
        if (ft === 'eS'){
          return {t:ft, i:firstNode.i, s:firstNode.s, n:firstNode.n, a:firstNode.a, v, p:getP(nos1)};
        }else if (ft === 'eV'){
          return {t:ft, i:firstNode.i, s:firstNode.s, v, p:getP(nos1)};
        }
      }else if (ft === 'pl'){
        return {t:ft, v:firstNode.v, p:firstNode.p, ti:firstNode.ti};
      }else if (ft === 'footer'){
        return {t:ft}
      }else if (CoreFns.directV(ft) || ft === 'pa' || ft === 'al' ){ //excludes f and gin
        return {t:ft,v:firstNode.v};
      }else if (CoreFns.withP(ft)  || ft === 'inP'){
        var nos = 0;
        if (ft === 'aC'){
          var isInside = false;
          var toComp = actionCases;
          for (var i15 = 0; i15 < toComp.length; i15++){
            if (toComp[i15].k === firstNode.v.k && toComp[i15].s === firstNode.v.s){
              isInside = true;
              break;
            }
          }
          if (!isInside){
            errorMsg = "This action variable no longer exists";
            goToAKeyPath(keyPath, thisPathDown);
            return;
          }
          //we should probably check that inC and inP exist. 
        }else if (ft === 'oVar'){
          //we should probably check that oVar exist. 
        }else if (ft === 'inP'){
          //we should probably check that inP exist. 
        }else if (ft === 'gV'){
          var firstP = firstNode.v.join(' ');
          var hereP = oPath.join(' ');
          if (hereP.indexOf(firstP) === 0){
          }else{
            if (oPath[0] === 'as'){
              var ppXX = SearchForAnEntityWithPath.searchEntity(currentList, oPath[1]);
              if (ppXX){
                var newHere = ppXX.path.join(' ');
                if (newHere.indexOf(firstP) === 0){
                }else{
                  return false;
                }
              }else{
                return false;
              }
            }else{
              return false;
            }
          }
        }else if (ft === 'm'){
          var haveFound = false;
          for (var i9 = 0; i9 < mapsAndFiltersAbove.length; i9++){
            var mm = mapsAndFiltersAbove[i9];
            if (firstNode.v === mm.m0 || firstNode.v === mm.m1){
              haveFound = true;
              break;
            }
          }
          if (!haveFound){
            errorMsg = "This variable no longer exists";
            goToAKeyPath(keyPath, thisPathDown);
            return;
          }
        }else{
          console.warn(firstNode);
        }

        var x = {t:ft,v:firstNode.v,p:getP(nos)};
        return x;        
      }else if (ft === 'u'){
        errorMsg = 'Missing Node';
        goToAKeyPath(keyPath, thisPathDown);
        return;
      }else{
        console.warn(firstNode);
      }
    }

    var tt = pieceTogetherTree([], [], []);
    if (errorMsg){
      window.alert(errorMsg);
      return false;
    }else{
      return tt;
    }
  }